interface AiDbResultsGridProps {
  columns: string[];
  rows: Record<string, unknown>[];
  maxRows?: number;
}

export function AiDbResultsGrid({ columns, rows, maxRows = 50 }: AiDbResultsGridProps) {
  const visible = rows.slice(0, maxRows);
  if (!columns.length) {
    return (
      <p className="text-xs text-slate-500" dir="rtl">
        لا توجد أعمدة — الاستعلام أعاد مجموعة فارغة.
      </p>
    );
  }

  return (
    <div className="overflow-auto rounded-lg border border-slate-200">
      <table className="min-w-full text-left text-xs" dir="ltr">
        <thead className="bg-slate-50 text-slate-600">
          <tr>
            {columns.map((col) => (
              <th key={col} className="whitespace-nowrap px-2 py-1.5 font-semibold">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {visible.map((row, i) => (
            <tr key={i} className="border-t border-slate-100 odd:bg-white even:bg-slate-50/50">
              {columns.map((col) => (
                <td key={col} className="max-w-[220px] truncate px-2 py-1.5 font-mono text-[11px]">
                  {formatCell(row[col])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length > maxRows && (
        <p className="border-t border-slate-100 px-2 py-1 text-[10px] text-slate-500" dir="rtl">
          عرض {maxRows} من {rows.length} صف
        </p>
      )}
    </div>
  );
}

function formatCell(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
